import API from '@/api';
const Specialization = API.get('Specialization');

export default ({
  namespaced: true,
  state: {
    specializations: [],
  },
  getters: {
    specializations: state => state.specializations,
  },
  mutations: {
    setSpecializations(state, specializations) {
      state.specializations = specializations
    },
  },
  actions: {
    async fetchSpecializations(state) {
      var response = await Specialization.get();
      state.commit('setSpecializations', response.data.data)
    },
  }
})